import React, { FunctionComponent } from 'react';

import charityLogo1 from './assets/charity_logo_1.png';
import charityLogo2 from './assets/charity_logo_2.png';
import styles from './CharityFooter.module.scss';

interface CharityFooter {
  joinNowLink: string;
}

export const CharityFooter: FunctionComponent<CharityFooter> = ({
  joinNowLink,
}) => {
  return (
    <div className={styles.charityFooter}>
      <div className="jg-grid-container">
        <section className="jg-grid-row">
          <p
            className={`${styles.charityFooterSubHeader} jg-h3 jg-text-xl jg-grid-col-s-12`}
          >
            Join{' '}
            <span className={styles.charitiesNumber}>25,788 charities</span>,
            organisations and schools on JustGiving
          </p>
          <div
            className={`${styles.charityImageContainer} jg-grid-col-s-12 jg-grid-row`}
          >
            <div className="jg-grid-col-s-12 jg-grid-col-l-6">
              <div className={styles.charityImageSet1}>
                <img src={charityLogo1} alt="charity logo" />
              </div>
            </div>
            <div className="jg-grid-col-s-12 jg-grid-col-l-6">
              <div className={styles.charityImageSet2}>
                <img src={charityLogo2} alt="charity logo" />
              </div>
            </div>
          </div>
          <div className={`jg-grid-col-s-12 jg-h4 ${styles.charityQuestion}`}>
            <div className="jg-h2">Do you work for a charity?</div>
          </div>
          <div className="loh-blue-default-link">
            <a
              role="button"
              type="button"
              className={`jg-btn--ghost jg-space-mbm ${styles.lohCharityButton} ${styles.lohJoinNowFdrButton}`}
              href={joinNowLink}
            >
              Join now
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};
